import React from 'react';
import './Clinic.css';

import entrada from '../images/clinica/entrada.jpeg';
import entrada2 from '../images/clinica/entrada2.jpg';
import letrero from '../images/clinica/letrero.jpeg';
import camilla from '../images/clinica/camilla.jpeg';
import camilla2 from '../images/clinica/camilla2.jpeg';
import material from '../images/clinica/material.jpeg';
import mesa from '../images/clinica/mesa.jpeg';
import puertabano from '../images/clinica/puertabaño.jpeg';
import sala from '../images/clinica/18A Sala 2.jpg';

const Clinic = () => {
    const images = [
        { src: entrada, alt: 'Entrada de la clínica' },
        { src: entrada2, alt: 'Entrada principal' },
        { src: letrero, alt: 'Letrero de la clínica' },
        { src: camilla, alt: 'Sala de tratamiento con camilla' },
        { src: camilla2, alt: 'Camilla de fisioterapia' },
        { src: material, alt: 'Material de fisioterapia' },
        { src: mesa, alt: 'Mesa de trabajo' },
        { src: puertabano, alt: 'Instalaciones' },
        { src: sala, alt: 'Sala de tratamiento' }
    ];

    return (
        <div className="clinic-page">
            <div className="clinic-header">
                <h1>Nuestras Clínicas</h1>
                <p>Instalaciones modernas y equipadas para tu mejor recuperación</p>
            </div>

            <div className="container">
                <div className="clinic-intro">
                    <p>
                        Contamos con dos clínicas completamente equipadas en Pinseque y Pedrola,
                        diseñadas para ofrecerte el mejor servicio de fisioterapia en un ambiente
                        cómodo y profesional.
                    </p>
                </div>

                <div className="clinic-gallery">
                    {images.map((image, index) => (
                        <div key={index} className="gallery-item">
                            <img
                                src={image.src}
                                alt={image.alt}
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>

                <div className="clinic-features">
                    <h2>Nuestras Instalaciones</h2>
                    <div className="features-grid">
                        <div className="feature-card">
                            <h3>Equipamiento Moderno</h3>
                            <p>Tecnología de última generación para tratamientos efectivos</p>
                        </div>
                        <div className="feature-card">
                            <h3>Salas Privadas</h3>
                            <p>Espacios individuales para tu comodidad y privacidad</p>
                        </div>
                        <div className="feature-card">
                            <h3>Ambiente Acogedor</h3>
                            <p>Diseñadas para tu bienestar y relajación</p>
                        </div>
                        <div className="feature-card">
                            <h3>Accesibilidad</h3>
                            <p>Instalaciones adaptadas para todas las necesidades</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Clinic;
